import {
  UPDATE_FIELD,
  UPDATE_FILE,
  SET_CONFIG,
  RESET_FILES,
  RESET_CONFIG
} from "../../constants/reduxActionTypes";

export const updateField = content => ({
  type: UPDATE_FIELD,
  payload: {
    ...content
  }
});

export const updateFile = content => ({
  type: UPDATE_FILE,
  payload: {
    ...content
  }
});
export const setConfig = content => ({
  type: SET_CONFIG,
  payload: {
    config: content
  }
});

export const resetConfig = () => ({
  type: RESET_CONFIG
});

export const resetFiles = () => ({
  type: RESET_FILES
});



// WEBPACK FOOTER //
// ./src/redux/actions/configActions.js